import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";

import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../theme";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AlertDialogSlide(props) {
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    props.confirm();
  };

  const handleClose = () => {
    props.not();
  };

  return (
    <div>
      <Dialog
        open={props.open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle style={{ fontSize: "0.8rem" }}>
          {props.data.primary}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-slide-description"
            style={{ fontSize: "0.6rem" }}
          >
            {props.data.secondary}
          </DialogContentText>
        </DialogContent>
        <ThemeProvider theme={theme}>
          <DialogActions>
            <Button color="neutral" onClick={handleClose}>
              {props.data.no}
            </Button>
            <Button color="neutral" onClick={handleClickOpen}>
              {props.data.yes}
            </Button>
          </DialogActions>
        </ThemeProvider>
      </Dialog>
    </div>
  );
}
